import MultiSortModal from './MultiSortModal.component';

export default MultiSortModal;